import React from "react";

const Footer = () => {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright">
            {" "}
            contact support: <a href="mailto:sangtt07121996@gmail.com">sangtt07121996@gmail</a>
          </div>

        </div>
      </div>
    </div>
  );
};
export default Footer;
